"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const WeatherIcon_1 = __importDefault(require("./WeatherIcon"));
const DayForecastWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  gap: 2.56vw;

  @media (orientation: portrait) {
    flex-direction: column;
  }

  .weather-icon {
    width: 12vmin;
    height: 12vmin;
    margin: 0 auto;
    
    i {
      height: 100%;
      display: flex;
    }
  }
`;
const DayName = styled_components_1.default.div `
  font-size: 3.8vmin;
  color: #fff;
  font-weight: 400;

  @media (orientation: portrait) {
    font-size: 4vmin;
    flex-basis: 30%;
    text-align: left;
  }
`;
const Temperature = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5vmin;
  
  .temperature-min {
    font-size: 3.6vmin;
    font-weight: 400;
    color: #ccffffff;
    text-align: left;
    width: 1.5em;
    
    @media (orientation: portrait) {
      font-size: 4vmin;
    }
  }

  .temperature-max {
    font-size: 4vmin;
    font-weight: 500;
    color: #fff;
    letter-spacing: -0.33px;
    text-align: right;
    width: 1.5em;

    
    @media (orientation: portrait) {
      font-size: 4vmin;
    }
  }
  

`;
const Day = styled_components_1.default.div `
  width: 24%;
  background: rgba(225, 225, 225, 30%);
  border-radius: 24px;
  padding: 2vmin 4vmin;
  text-align: center;
  box-shadow: 0px 3px 16px 0px rgba(179, 179, 179, 0.1);

  height: 35vmin;

  display: flex;
  flex-direction: column;
  justify-content: center;

  &.bareiss {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: ${() => "url( /images/other/bareissTransparent.png )"};
  }

  @media (orientation: portrait) {
    width: 100%;
    height: auto;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
const DayForecastNew = (props) => {
    const renderDayForecast = (forecast) => {
        const date = new Date(forecast.date);
        const dayOfTheWeek = i18n_js_1.default.t("dictionary.dayNames")[date.getDay()];
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(DayName, { className: "day-week-name" }, dayOfTheWeek),
            react_1.default.createElement(WeatherIcon_1.default, { symbol: forecast.symbol }),
            react_1.default.createElement(Temperature, null,
                react_1.default.createElement(material_1.Typography, { className: "temperature-min" },
                    " ",
                    forecast.min,
                    "\u00B0",
                    " "),
                react_1.default.createElement(material_1.Typography, { className: "temperature-max" },
                    " ",
                    forecast.max,
                    "\u00B0",
                    " "))));
    };
    const { stopAnimationsInSlide } = props.settings || {};
    const { venue } = props;
    // without this class animations do not trigger
    const mainAnimationClass = stopAnimationsInSlide ? "" : "animate__animated";
    const bareissClass = venue && venue.brandSlug === "bareiss" ? "bareiss" : "";
    return (react_1.default.createElement(DayForecastWrapper, { currentWeatherIsBad: props.currentWeatherIsBad },
        react_1.default.createElement(Day, { className: `${mainAnimationClass} ${bareissClass} day-1` },
            " ",
            renderDayForecast(props.forecast[0]),
            " "),
        react_1.default.createElement(Day, { className: `${mainAnimationClass} ${bareissClass} day-2` },
            " ",
            renderDayForecast(props.forecast[1]),
            " "),
        react_1.default.createElement(Day, { className: `${mainAnimationClass} ${bareissClass} day-3` },
            " ",
            renderDayForecast(props.forecast[2]),
            " "),
        react_1.default.createElement(Day, { className: `${mainAnimationClass} ${bareissClass} day-4` },
            " ",
            renderDayForecast(props.forecast[3]),
            " ")));
};
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DayForecastNew);
